/* esm.sh - applesauce-core@5.2.0/operations/mailboxes */
export * from "/*applesauce-core@5.2.0/esnext/operations/mailboxes.mjs";
